export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatBitcoin = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: value < 1 ? 3 : 2,
    maximumFractionDigits: value < 1 ? 3 : 2,
  }).format(value);
};

export const formatBitcoinDetailed = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: value < 1 ? 5 : 3,
    maximumFractionDigits: value < 1 ? 5 : 3,
  }).format(value);
};